import type { ShapeData } from '@/lib/shapes/types/shape-data'
import type { TextBoxData } from '@/lib/text/types/text-box-data'

/** True if `text` is nested under `groupId` (direct child or deeper). */
export function isTextUnderGroup(
  text: TextBoxData,
  groupId: string,
  shapesById: Map<string, ShapeData>
): boolean {
  let gid: string | undefined = text.parentGroupId

  while (gid) {
    if (gid === groupId) return true
    gid = shapesById.get(gid)?.parentGroupId
  }

  return false
}

/** True if any shape ancestor of `text` (via `parentGroupId` chain) has `locked === true`. */
export function isTextUnderLockedAncestor(
  text: TextBoxData,
  shapesById: Map<string, ShapeData>
): boolean {
  let gid: string | undefined = text.parentGroupId

  while (gid) {
    const ancestor = shapesById.get(gid)

    if (!ancestor) break
    if (ancestor.locked === true) return true
    gid = ancestor.parentGroupId
  }

  return false
}
